<template>
  <div class="row">
    <internal-comment-block
      v-model="form.application.internal_comment"
      v-if="canShowInternalComment"
      :form="form"
    />
    <div class="col-md-4">
      <organization-subject-input
        v-model="organization.subject_id"
        :form="form"
        :errors="errors"
        :items="organizationSubjects"
        :nationalities-list="nationalitiesList"
        :organization-subjects-residency="organizationSubjectsResidency"
        :selected-nationality="selectedNationality"
        :disabled="disabledSubject"
        @change="change($event); cleanPrevValues()"
      >
        <template v-slot:selectNationality>
          <b-dropdown
            :id="'organization-subject-input'"
            toggle-class="right-border-radius-unset right-border-none subject-input-dropdown"
            :disabled="disabledSubject"
            ref="dropdown"
            class="subject-input-residency-list"
          >
            <template #button-content>
              <img
                v-if="selectedNationality"
                class="flag_img subject-input-flag"
                :src="selectedNationalityImage"
                :alt="selectedNationality.iso2"
              />
              <slot name="arrow-icon" :open="nationalityListIsOpen">
              <span class="vti__dropdown-arrow subject-input-arrow" v-if="isView === false">
                {{ nationalityListIsOpen ? '▲' : '▼' }}
              </span>
              </slot>
            </template>
            <template v-for="(nationality, key) in nationalities">
              <b-dropdown-item
                :key="key"
                :style="{cursor: 'pointer'}"
                @click="changeNationality(nationality)"
              >
                <img class="flag_img" :src="iconsPath + nationality.iso2 + '.svg'" alt="" width="20"/>
                <span style="margin-left: 5px"
                ><strong>{{ nationality.full_name }}</strong></span
                >
              </b-dropdown-item>
            </template>
            <slot name="lastItems"></slot>
          </b-dropdown>
        </template>
      </organization-subject-input>
    </div>
    <div class="col-md-8">
      <organization-name-input
        v-model="organization.name"
        :form="form"
        :errors="errors"
        :typeahead="typeaheadOrganizationName"
        :select-typeahead="selectTypeaheadOrganization"
        :nationalities-list="nationalitiesList"
        :location-name="locationName"
        :disabled="disabledName"
        :input-label="organizationNameInputLabel"
        @switch-location-name="switchLocationName"
        @change="change($event); cleanContactFields()"
      />
    </div>
    <div class="col-md-4">
      <organization-inn-input
        v-model="organization.inn"
        :form="form"
        :errors="errors"
        :typeahead="typeaheadOrganizationInn"
        :select-typeahead="selectTypeaheadOrganization"
        :organization-subjects-residency="organizationSubjectsResidency"
        :disabled="disabledInn"
        @change="change($event); cleanContactFields()"
      />
    </div>
    <div class="col-md-4">
      <organization-manager-position-input
        v-model="organization.position_of_manager"
        :form="form"
        :errors="errors"
        :prevValue="prevManagerPosition"
        :disabled="disabledPositionOfManager"
        @change="change"
      />
    </div>
    <div class="col-md-4">
      <organization-manager-name-input
        v-model="organization.director_name"
        :form="form"
        :errors="errors"
        :prevValue="prevManagerName"
        :disabled="disabledDirectorName"
        @change="change"
      />
    </div>
    <div class="col-md-12">
      <organization-address-input
        v-model="organization.address"
        :form="form"
        :errors="errors"
        :typeahead="typeaheadOrganizationAddress"
        :prevValue="prevAddress"
        :disabled="disabledAddressField"
        @change="change"
        ref="organizationName"
      />
    </div>
    <!--    <div class="col-md-12">-->
    <!--      <organization-fiz-address-input-->
    <!--          v-model="organization.fiz_address"-->
    <!--          :form="form"-->
    <!--          :errors="errors"-->
    <!--          :typeahead="typeaheadOrganizationFizAddress"-->
    <!--          :prevValue="prevAddress"-->
    <!--          :disabled="disabledOrganizationField"-->
    <!--          @change="change('organization fizAddress')"-->
    <!--          @input="change('organization fizAddress')"-->
    <!--      />-->
    <!--    </div>-->
    <div class="col-md-4">
      <organization-phone-input
        v-model="organization.phone"
        :form="form"
        :errors="errors"
        :disabled="disabledPhone"
        @change="change"
      />
    </div>
    <div class="col-md-4">
      <organization-email-input
        v-model="organization.email"
        :form="form"
        :errors="errors"
        :disabled="disabledEmail"
      />
    </div>
    <div class="col-md-4">
      <organization-website-input
        v-model="organization.website"
        :form="form"
        :errors="errors"
        :disabled="disabledWebsiteField"
      />
    </div>
    <div v-if="visibleContractFields" :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_NUMBER)">
      <contract-number-input
        v-model="form.application.contract_number"
        :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_NUMBER)"
        :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_NUMBER)"
        :form="form"
        :errors="errors"
        :disabled="disabledInput"
      />
    </div>
    <div v-if="visibleContractFields" :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_DATE_OF)">
      <contract-date-input
        v-model="form.application.contract_date"
        :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_DATE_OF)"
        :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_DATE_OF)"
        :form="form"
        :errors="errors"
        :disabled="disabledInput"
        :max-date="currentMomentDate.clone()"
      />
    </div>
    <div v-if="visibleContractFields" :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_DATE_TO)">
      <contract-end-date-input
        v-model="form.application.contract_end_date"
        :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_DATE_TO)"
        :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_DATE_TO)"
        :form="form"
        :errors="errors"
        :disabled="disabledInput || form.application.contract_unlimited"
        :min-date="minDateContractEndDate"
      />
      <div slot="after">
        <label class="applicant-helpers flex-label">
          <input
            v-model="form.application.contract_unlimited"
            type="checkbox"
            :disabled="disabledInput"
            @change="clearContractEndDate"
          />
          &nbsp;
          Бессрочный
        </label>
      </div>
    </div>
    <div v-if="visibleContractFields" :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_ORG_NAME)">
      <contract-org-name-input
        v-model="form.application.contract_org_name"
        :terminal-organizations="terminalOrganizations"
        :typeahead="typeaheadContractOrgName"
        :select-typeahead="selectTypeaheadContractOrgName"
        :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_ORG_NAME)"
        :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_ORG_NAME)"
        :form="form"
        :errors="errors"
        :disabled="disabledInput"
        @change-contract-organization="$emit('change-contract-organization', $event)"
      />
    </div>
    <div v-if="visibleContractFields" :class="'col-md-' + fieldWidth(OrganizationSectionFieldAliases.CONTRACT_ORG_INN)">
      <contract-org-inn-input
        v-model="form.application.contract_org_inn"
        :input-label="fieldTitle(OrganizationSectionFieldAliases.CONTRACT_ORG_INN)"
        :input-hint="fieldHint(OrganizationSectionFieldAliases.CONTRACT_ORG_INN)"
        :form="form"
        :errors="errors"
        :disabled="disabledInput"
      />
    </div>
  </div>
</template>

<script>
// TODO Some fields have no purpose because they are needed for compatibility with the current state of the task 3092
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import mainMixin from '@/common/mixins/mainMixin'
import OrganizationSubjectInput from '@/common/components/application/form-inputs/organization/OrganizationSubjectInput.vue'
import OrganizationNameInput from '@/common/components/application/form-inputs/organization/OrganizationNameInput.vue'
import OrganizationInnInput from '@/common/components/application/form-inputs/organization/OrganizationInnInput.vue'
import OrganizationManagerPositionInput from '@/common/components/application/form-inputs/organization/OrganizationManagerPositionInput.vue'
import OrganizationManagerNameInput from '@/common/components/application/form-inputs/organization/OrganizationManagerNameInput.vue'
import OrganizationAddressInput from '@/common/components/application/form-inputs/organization/OrganizationAddressInput.vue'
import OrganizationPhoneInput from '@/common/components/application/form-inputs/organization/OrganizationPhoneInput.vue'
import { Logger } from '@/common/helpers/Logger'
import { UserRoles } from '@/common/enums/UserRoles'
import InternalCommentBlock from '@/common/components/application/internalCommentBlock.vue'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import permissionsMixin from '@/common/mixins/PermissionsMixin'
import OrganizationDto from '@/common/classes/dto/OrganizationDto'
// import OrganizationFizAddressInput from '@/common/components/application/form-inputs/organization/OrganizationFizAddressInput.vue'
import OrganizationEmailInput from '@/common/components/application/form-inputs/organization/OrganizationEmailInput.vue'
import OrganizationWebsiteInput from '@/common/components/application/form-inputs/organization/OrganizationWebsiteInput.vue'
import ContractNumberInput from '@/common/components/application/form-inputs/pass/ContractNumberInput.vue'
import ContractDateInput from '@/common/components/application/form-inputs/pass/ContractDateInput.vue'
import ContractEndDateInput from '@/common/components/application/form-inputs/pass/ContractEndDateInput.vue'
import OrganizationSectionFieldAliases from '@/common/enums/OrganizationSectionFieldAliases'
import moment from 'moment-timezone'
import ContractOrgNameInput from '@/common/components/application/form-inputs/organization/ContractOrgNameInput.vue'
import ContractOrgInnInput from '@/common/components/application/form-inputs/organization/ContractOrgInnInput.vue'

export default {
  name: 'OrganizationFormBlock',
  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    permissionsMixin
  ],

  components: {
    ContractOrgInnInput,
    ContractOrgNameInput,
    ContractEndDateInput,
    ContractDateInput,
    ContractNumberInput,
    OrganizationWebsiteInput,
    OrganizationEmailInput,
    // OrganizationFizAddressInput,
    InternalCommentBlock,
    OrganizationSubjectInput,
    OrganizationNameInput,
    OrganizationInnInput,
    OrganizationManagerPositionInput,
    OrganizationManagerNameInput,
    OrganizationAddressInput,
    OrganizationPhoneInput
  },

  data: () => ({
    locationName: 'all',
    locations: [],
    nationalityListIsOpen: false,
    prevManagerPosition: '',
    prevManagerName: '',
    prevAddress: ''
  }),

  model: {
    prop: 'organization',
    event: 'change-organization'
  },

  props: {
    applicationPurposes: {
      type: [Array, Object],
      default: () => []
    },

    cfgFormFields: {
      type: [Array, Object],
      default: () => []
    },

    organization: {
      type: Object,
      required: true
    },

    organizationDisabled: {
      type: Boolean,
      default: () => false
    },

    organizationSubjects: {
      type: Array,
      default: () => []
    },

    nationalitiesList: {
      default: []
    },

    organizationSubjectsResidency: {
      default: []
    },

    timezone: {
      type: String,
      default: 'Europe/Moscow'
    },

    terminalOrganizations: {
      type: Array,
      default: () => []
    }
  },

  created() {
    if (this.organization.inn && (this.isNew || this.isDuplicate) && this.form.organization.nationality_id === 182) {
      this.getOrganizationSuggestions(this.organization.inn, true, true)
        .then(result => {
          result = result ?? []
          const firstSuggestion = result[0] ?? {}
          this.prevManagerName = firstSuggestion.director_name ?? ''
          this.prevManagerPosition = firstSuggestion.position_of_manager ?? ''
          this.prevAddress = firstSuggestion.address ?? ''
          this.$store.dadataManagerName = firstSuggestion.director_name ?? ''
          this.$store.dadataManagerPosition = firstSuggestion.position_of_manager ?? ''
        });
    }
  },

  computed: {
    OrganizationSectionFieldAliases() {
      return OrganizationSectionFieldAliases
    },

    organizationNameInputLabel() {
      return this.isEntityOrganizationSubject || this.isGkoOrganizationSubject || this.isTerminalSubject || this.isForeignSubject
        ? 'Наименование организации'
        : 'Фамилия, имя, отчество'
    },

    applicationPurpose() {
      return this.applicationPurposes[this.form.application.application_group_purpose_id]
    },

    currentMomentDate() {
      return moment().tz(this.timezone)
    },

    disabledBySystem() {
      return Boolean(this.disabledInput || this.organizationDisabled)
    },

    disabledOrganizationFields() {
      return Boolean(this.disabledBySystem || this.isTerminalSubject)
    },

    disabledForTrustedUser() {
      const trustedRolesRequiresOrganizationId = [
        UserRoles.SUBDIVISION,
        UserRoles.SB,
        UserRoles.SB_TRUCK,
        UserRoles.SB_OTHER
      ]

      return Boolean(
        this.user?.role === UserRoles.TRUSTED_USER ||
        (trustedRolesRequiresOrganizationId.includes(this.user?.role) && this.user?.organization_id)
      )
    },

    disabledSubject() {
      return Boolean(this.disabledBySystem || this.disabledForTrustedUser)
    },

    disabledName() {
      if (this.disabledOrganizationFields) {
        return true
      }

      if (this.isFizOrganizationSubject) {
        return false
      }

      return this.disabledForTrustedUser
    },

    disabledInn() {
      return Boolean(this.disabledOrganizationFields || this.disabledForTrustedUser || this.isForeignSubject)
    },

    disabledPositionOfManager() {
      return Boolean(this.disabledOrganizationFields)
    },

    disabledDirectorName() {
      return Boolean(this.disabledOrganizationFields || this.isFizOrganizationSubject)
    },

    disabledAddressField() {
      return Boolean(this.disabledOrganizationFields || this.isFizOrganizationSubject)
    },

    disabledPhone() {
      return Boolean(this.disabledBySystem)
    },

    disabledEmail() {
      return Boolean(this.disabledBySystem)
    },

    disabledWebsiteField() {
      return Boolean(this.disabledOrganizationFields || this.isFizOrganizationSubject)
    },

    canShowInternalComment() {
      return this.hasPermission(PermissionsEnum.canUseInternalComment) && this.isView
    },

    iconsPath() {
      return process.env.BASE_URL + 'img/icons/countries/'
    },

    nationalities() {
      const nationalitiesIds = [
        ...new Set(this.organizationSubjectsResidency.map((value) => Number(value.nationality_id)))
      ]

      return this.nationalitiesList.filter(nationality => nationalitiesIds.includes(nationality.id))
    },

    selectedNationality() {
      return this.nationalities.find(nationality => nationality.id === this.form.organization.nationality_id) ??
        this.nationalities.find(nationality => nationality.iso2 === 'RU')
    },

    selectedNationalityImage() {
      return this.iconsPath + this.selectedNationality.iso2 + '.svg'
    },

    visibleContractFields() {
      return this.isCurrentContractFieldsDisplay &&
        !this.isTerminalSubject &&
        !this.isGkoOrganizationSubject
    },

    minDateContractEndDate() {
      return this.currentMomentDate.clone()
    }
  },

  methods: {
    cleanContactFields() {
      // this.organization.phone = null; TODO phone widget steal input focus
      this.organization.email = null;
      this.organization.website = null;
    },

    cleanPrevValues() {
      this.prevManagerName = null
      this.prevManagerPosition = null
      this.prevAddress = null
    },

    change(inputName) {
      Logger.log(`Changed ${inputName}`)
      this.$emit('change-organization', this.organization)
    },

    changeNationality(nationality) {
      const organization = Object.assign({}, this.organization, { nationality_id: nationality.id })
      Logger.log(`Changed nationality ${nationality.id}!`)
      this.prevAddress = this.organization.address
      this.prevManagerName = this.organization.director_name
      this.prevManagerPosition = this.organization.position_of_manager
      this.$emit('change-organization', organization)
    },

    switchLocationName() {
      this.locationName = this.locationName !== 'all' ? 'all' : this.configuration?.find_region ?? 'nw'
    },

    /**
     * @param {TypeaheadOrganization} item
     */
    selectTypeaheadOrganization(item) {
      if (this.isFizOrganizationSubject) {
        if (item instanceof Object) {
          const organization = Object.assign({}, new OrganizationDto({}), this.organization, {
            name: item.value,
            short_name: item.short_name
          })
          this.$emit('change-organization', organization)
        }

        return
      }

      if (item === null) {
        item = this.organization.innData
      }

      if (item instanceof Object) {
        const organization = Object.assign({}, new OrganizationDto({}), this.organization, {
          inn: item.inn,
          innData: item.inn,
          address: item.address ?? null,
          position_of_manager: item.position_of_manager ?? null,
          director_name: item.director_name ?? null,
          name: item.org_name,
          short_name: item.short_name
        })
        this.$emit('change-organization', organization)
        this.prevAddress = item.address ?? ''
        this.prevManagerName = item.director_name ?? ''
        this.prevManagerPosition = item.position_of_manager ?? ''
        this.$store.dadataManagerName = item.director_name ?? ''
        this.$store.dadataManagerPosition = item.position_of_manager ?? ''
      }
    },

    typeaheadOrganizationAddress(query, done) {
      this
        .typeaheadAddresses(query, done, false, 'organization')
        .then(() => this.resetTypeaheadActiveIndex(this.$refs.organizationName.$refs.addressRef))
    },

    clearContractEndDate() {
      if (this.form.application.contract_unlimited) {
        this.form.application.contract_end_date = null
      }
    },

    /**
     * @param {TypeaheadOrganization} item
     */
    selectTypeaheadContractOrgName(item) {
      if (item === null || !(item instanceof Object)) {
        return
      }

      const organization = new OrganizationDto({
        inn: item.inn,
        name: item.org_name,
        short_name: item.short_name
      })
      this.$emit('change-contract-organization', organization)
    }
  },

  watch: {
    'organization.inn': function (inn) {
      this.form.application.documents = []
      this.checkInnControlSum()
    },
    'organization.name': function (name) {
      this.checkVisitorOrganizationBlock()
      this.checkInnControlSum()
    }
  }
}
</script>
